import { FeedbackLabel, FeedbackLabelType } from 'v2/core/entities/feedback';
import { ReasonOrEntityLabelType } from 'v2/core/entities/feedback/labels';

export const getReasonOrEntityLabels = (labels: FeedbackLabel[]) => {
  return labels.filter(
    (label): label is ReasonOrEntityLabelType =>
      label.type === FeedbackLabelType.Reason ||
      label.type === FeedbackLabelType.Entity,
  );
};
